<template lang="pug">
    .game-content
        games-wrapper(
            :type="type"
            :exercise-id="exerciseId"
            :homework-id="homeworkId"
            :players-number="currentPlayersAmount"
            :check-multiplayer-answers="checkMultiplayerAnswers"
            :play-again="playAgain"
            @playAgainReady="$event ? playAgainReadyScreens++ : playAgainReadyScreens--"
            @checkAnswersReady="handleCheckAnswersReadyEvent"
            :continue-game-event="continueGameEvent"
            :common-parameters-changer-counter="commonParametersChangerCounter"
            :multiplayer-games-state="multiplayerGamesState"
            :refresh-game-event="refreshGameEvent"
        )
</template>

<script>
    import PlayBox from './PlayBox.vue';
    import GamesWrapper from '../../../trainer/games/GamesWrapper.vue';
    import MultiplayerCommonMenuMixin from '../../../../utils/multiplayer/commonMenuMixin';

    export default {
        props: ['exerciseId', 'homeworkId', 'type', 'sameSettingsAreActive'],
        mixins: [MultiplayerCommonMenuMixin],
        data() {
            return {
                showTurtle: true,
                playAgain: false,
            };
        },
        methods: {
            sendPlayAgainEvent() {
                this.playAgain = true;
                this.$nextTick(() => {
                    this.playAgain = false;
                });
            },
            handleCurrentGameParametersChange(parameter) {
                let newParamsArray = this.paramsArray;
                newParamsArray.forEach(params => {
                    if (parameter.setOperationsValues) {
                        parameter.names.forEach((operationName, index) => {
                            params.operations[operationName] = parameter.values[index];
                        });
                        return;
                    }
                    params[parameter.name] = parameter.value;
                });
                this.$store.dispatch('setParamsArray', newParamsArray);
            },
        },
        components: {
            PlayBox,
            GamesWrapper,
        },
        beforeRouteLeave(to, from, next) {
            if (this.$store.state.trainer.game) {
                if (!(to.meta.type && to.meta.type === 'trainer')) {
                    this.$store.dispatch('setHomework', null);
                    this.$store.dispatch('setGame', null);
                }
            }
            next();
        },
    };
</script>

<style lang="scss" scoped>
    .menu {
        width: 100%;
        margin-bottom: 5px;
        @include media($xl) {
            margin-bottom: 10px;
        }
    }

    @import '@/assets/sass/games/main.scss';
</style>
